export const selectGuestCheckoutCustomer = state => state.guestCheckout.customer

export const selectGuestCheckoutHasEnabled = state =>
  state.guestCheckout.enabled

export const selectLatesGuestEmail = state => state.guestCheckout.lastGuestEmail
